export default __webpack_public_path__ + "static/media/sequence_right_t.5f279fe3.png";